var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`px-2 py-1/2 rounded-full text-[9px] uppercase tracking-wide ${_vm.badgeClass}`},[_vm._v("\n    "+_vm._s(_vm.badgeText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }